module.exports = __webpack_public_path__ + "static/img/dev4.a576878.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/dev4.jpg
// module id = yd0t
// module chunks = 1